import React, {useCallback, useEffect, useRef, useState } from 'react'
import { reformat } from '../../../../hooks/useMyStrings';
import { useConfigPathContext } from '../../../../providers/ConfigPathContextProvider';
import useWebSocketCaller from '../../../../hooks/useWebSocketCaller';
import { useItemListenerContext } from '../../../../providers/ItemListenerContextProvider';
import ConfigErrorMsg from '../ConfigErrorMsg';
import './ProgKeyEdit.css';

/*
// Only for LOCAL validations.  Server validations would return to the created field?  IF we create a LOCAL node.  And only for LOCAL QUEUE.
{
  "message": "Invalid Programming Key",
  "cause": "Invalid Config Data: Prog Key: 1  2",
  "suggestion": "No spaces allowed, use only [ a-z, A-Z, 0-9, .-_ ] Use the Title field for a free text display name",
  "logFinder": "3e2b7e2b-7a24-4276-82ae-5514f212a347",

  "errorTag": "prop-prog-key",

  "basePath": "$.rootAccount.apps['Island Tower Server']['rels']['0.9']['envs']['Staging 1']['cfgs']['Main']['Lakes']",
  "oldKey": null,
  "newKey": "1  2",
  "val": null,
  "title": null,
  "requiredAction": null
}

//const kiponos_Info = 'kiponosInfo';
// const {createKey, keyCreatedError, resetCreateKeyError} = useContext(ConfigTableContext);
// const {
//   getCurrentFolder,
//   spreadConfigsData,
//   keyCreatedError, 
//   resetCreateKeyError, 
//   createKey
// } = useConfigItemsHandler();    
*/


export const CreateKeyStates = {
  IN_PROGRESS: 'keyNameInProgress',
  ERROR_INFO: 'keyCreatedErrorInfo',
}

const CreateProgKey = ({hideMe, withError, keyNameInProgress}) => {
  const {configPath}                 = useConfigPathContext();
  const {clearErrorKeyCreated, 
         tagCreateKeyInProgress, 
         resetCreateKeyInProgress}   = useItemListenerContext();
  const {sendMessage}                = useWebSocketCaller();
  const [content, setContent]        = useState('');
  const [errSubject, setErrSubject]  = useState(null);
  const [errBody, setErrBody]        = useState(null);
  const [style, setStyle]            = useState('progKeyEdit')
  const focusRef                     = useRef(null);

  useEffect(()=>{
    if (withError) {
      const {newKey, message, suggestion} = withError;
      setContent(newKey);
      setErrSubject(message);
      setErrBody(suggestion);
      setStyle('progKeyEdit error');
      focusRef.current.focus();
    }
  }, [withError]);
  
  useEffect(()=>{
    if (keyNameInProgress) {
      setContent(keyNameInProgress);
      setStyle(`progKeyEdit inProgress`);
    }
  }, [keyNameInProgress]);

  // ---[  Update Content  ]---
  //
  const updateContent = useCallback((e) => {
    const update = reformat(e.target.value);
    setContent(update);
    // TODO: 1. Block SAVE if key already exists
    //       2. Cosider editValidateMe(update) if necessary. The approach is to let the server validate and inform the error message.
  }, []);


  // ---[  Close Me  ]---
  //
  const closeMe = useCallback(() => {
    if (withError) {
      clearErrorKeyCreated(withError)
      .then(()=>resetCreateKeyInProgress(configPath))
      .then(hideMe);
    }
    else {
      hideMe();
    }
  }, [hideMe, clearErrorKeyCreated, withError, resetCreateKeyInProgress, configPath]);


  // ---------[   Submit  SAVE   ]--------- Call Server -----
  //
  const save = useCallback(() => {
      if (content) {
        clearErrorKeyCreated(withError)
          .then(()=> tagCreateKeyInProgress(configPath, content))
          .then(() => sendMessage('create-config-key', {
              basePath: configPath,
              key: content
          }));
      }
      else {
        closeMe();
      }
  }, [configPath, content, sendMessage, clearErrorKeyCreated, closeMe, withError, tagCreateKeyInProgress]);

  
  //---  KeyDown    [Enter] / [Esc]   ----------
  //
  const handleKeyDown = useCallback((e) => {
      if (e.key === 'Enter') {
        save();
      }
      else if (e.key === 'Escape') {
        closeMe();
      }
  }, [save, closeMe]);


  return (
      <div className={style}>
        {/* {errSubject && <NoteTooltip subject={errSubject} body={errBody} />} */}
        {errSubject && <ConfigErrorMsg subject={errSubject}
                                      body={errBody}
                                      cause={withError?.cause}
                                      onSide='left'/>}  

        {!keyNameInProgress && <input ref={focusRef}
                                      className='progKeyInput' 
                                      type='text' value={content}
                                      autoFocus={true}
                                      onChange={updateContent} 
                                      onBlur={save}
                                      onKeyDown={handleKeyDown}
                                      placeholder='new-programming-key'
                                      tabIndex='1'/>}

        {keyNameInProgress && <div className='progKeyInput inProgress'>{content}</div>}
      </div>
  )
}


export default React.memo(CreateProgKey);